import type { NostrEvent } from '@nostrify/nostrify';
import { cn } from '@/lib/utils';

interface NoteContentProps {
  event: NostrEvent;
  className?: string;
}

/** Minimal plain-text renderer for kind 1111 comment content. */
export function NoteContent({ event, className }: NoteContentProps) {
  return (
    <p className={cn('whitespace-pre-wrap break-words', className)}>
      {event.content}
    </p>
  );
}
